/**
 * Rounds to a fixed number of decimals without the floating point drift of
 * toFixed. Always run monetary values through this before sending them to the
 * payments API — it rejects values with more than 2 decimals.
 */
export const round2 = (value: number, digits = 2) =>
  Math.round(value * 10 ** digits + Number.EPSILON) / 10 ** digits;

export const formatEUR = (value: number) =>
  new Intl.NumberFormat("pt-PT", {
    style: "currency",
    currency: "EUR"
  }).format(value);

/** Parses a decimal input that may use a comma as the separator, as pt-PT does. */
export const parseDecimal = (value: string) =>
  Number.parseFloat(value.replace(",", "."));
